export const iParqueCookiesAcceptanceName = "IPCookies";
export const cookieDurationInMinutes = 525600; // 365 days
